import { Children, cloneElement, ReactElement, ReactNode } from 'react';

import { trackEvent } from '~/helpers/analytics';

import { filterProps, parseEventProperties, useBaseProperties } from './helpers';

interface SendEventOnClickProps {
  children?: ReactNode;
  elementName?: string;
  eventProperties?: string;
}

export const SendEventOnClick = ({ children, elementName, eventProperties, ...props }: SendEventOnClickProps) => {
  const baseProperties = useBaseProperties();
  return (
    <>
      {Children.map(children, (child) =>
        cloneElement(child as ReactElement, {
          ...filterProps(props), // forward extra props for composability
          onClick: () => {
            if (elementName) {
              trackEvent({
                name: `${elementName} clicked`,
                properties: {
                  ...baseProperties,
                  ...parseEventProperties(eventProperties),
                },
              });
            }
          },
        }),
      )}
    </>
  );
};
